
// https://confluence.mobvista.com/pages/viewpage.action?pageId=49642221
import RadioGroupFormItem from './radio-group-form-item.vue';
import demandMixin from './demand-mixin';

export default {
  mixins: [demandMixin],

  props: {
    demand: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'payment'
    },
    formItemList: {
      type: Object,
      required: true
    }
  },

  components: {
    RadioGroupFormItem: RadioGroupFormItem
  },

  computed: {
    visible: function visible() {
      return this.demand.category !== '';
    },
    revenueSummary: function revenueSummary() {
      return this.demand.revenue_usd ? '$' + this.demand.revenue_usd : '';
    },
    costSummary: function costSummary() {
      return this.demand.cost_usd || this.demand.cost_usd === 0 ? '$' + this.demand.cost_usd : '';
    }
  }
};